import TextLink from 'LuxKit/TextLink'
import Caption from 'LuxKit/Typography/Caption'
import config from 'constants/config'
import { staticPageMessages } from 'constants/config/i18nMessages'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

interface Props {
  modalType?: string
}

function AccountAccessLegalText({ modalType }: Props) {
  const intl = useIntl()
  const isPhonePromptModal = modalType === 'promptAddPhone'
  // Metasearch guest checkout discloses the account we create on the customer's
  // behalf, but not loyalty enrolment or marketing consent: those are handled
  // outside this flow. Registration still emits USER_SIGN_UP with nothing marking
  // it as a guest, so keep this copy in step with what its consumers actually do.
  const isGuestCheckout = modalType === 'guestCheckout'
  const termsURL = config.contentLinks.termsAndConditions.href || config.contentLinks.termsAndConditions.to!
  const privacyURL = config.contentLinks.privacyPolicy.href || config.contentLinks.privacyPolicy.to!
  const loyaltyEnabled = useAppSelector(getIsLoyaltyEnabled)
  const privacyPolicyText = intl.formatMessage(staticPageMessages.privacyPolicy)

  return (
    <Caption colour="light-foreground-alt" variant="medium">
      {isPhonePromptModal && (
        <FormattedMessage
          id="f7gNggeLDLd_akEFMuK5"
          defaultMessage="By adding your mobile number, you agree to our <termsLink>Terms & Conditions</termsLink> and <privacyLink>{privacyPolicy},</privacyLink> and to subscribe to marketing communications for offers, alerts and services."
          
          values={{
            privacyPolicy: privacyPolicyText,
            termsLink: (chunks: React.ReactNode) => <TextLink href={termsURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
            privacyLink: (chunks: React.ReactNode) => <TextLink href={privacyURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
          }}
        />
      )}
      {isGuestCheckout && (
        <FormattedMessage
          id="IE4OoLI-O_hIRu9mryRB"
          defaultMessage="You’ll enter your details at checkout so we can process and manage your booking. By continuing, you agree to our <termsLink>Terms & Conditions</termsLink> and <privacyLink>{privacyPolicy}</privacyLink>."
          
          values={{
            privacyPolicy: privacyPolicyText,
            termsLink: (chunks: React.ReactNode) => <TextLink href={termsURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
            privacyLink: (chunks: React.ReactNode) => <TextLink href={privacyURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
          }}
        />
      )}
      {!isGuestCheckout && !isPhonePromptModal && loyaltyEnabled && (
        <FormattedMessage
          id="sK1qEmWqIu7rciOqhrmT"
          defaultMessage="By continuing, you agree to our <termsLink>Terms & Conditions</termsLink> and <privacyLink>{privacyPolicy},</privacyLink> join the {loyaltyProgram} program, and to subscribe to marketing communications for offers, alerts and services."
          
          values={{
            privacyPolicy: privacyPolicyText,
            loyaltyProgram: getLoyaltyProgramDisplayName(),
            termsLink: (chunks: React.ReactNode) => <TextLink href={termsURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
            privacyLink: (chunks: React.ReactNode) => <TextLink href={privacyURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
          }}
        />
      )}
      {!isGuestCheckout && !isPhonePromptModal && !loyaltyEnabled && (
        <FormattedMessage
          id="znipBfcVHP8gqcqagn18"
          defaultMessage="By continuing, you agree to our <termsLink>Terms & Conditions</termsLink> and <privacyLink>{privacyPolicy},</privacyLink> and to subscribe to marketing communications for offers, alerts and services."
          
          values={{
            privacyPolicy: privacyPolicyText,
            termsLink: (chunks: React.ReactNode) => <TextLink href={termsURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
            privacyLink: (chunks: React.ReactNode) => <TextLink href={privacyURL} rel="noopener noreferrer" target="_blank" weight="regular">{chunks}</TextLink>,
          }}
        />
      )}
    </Caption>
  )
}

export default AccountAccessLegalText
